<div class="w-100 h-100 d-flex align-items-center justify-content-center" style="min-height: 75vh;">
    <div class="text-center pop-crack position-relative">
        <img *ngIf="badge == 'Bronze'" src="assets/icons/bronze-badge-large.svg" alt="">
        <img *ngIf="badge == 'Silver'" src="assets/icons/silver-badge-large.svg" alt="">
        <img *ngIf="badge == 'Gold'" src="assets/icons/gold-badge-large.svg" alt="">
        <p *ngIf="badge == 'Bronze'" class="mt-3 text-32-600-125 c-bronze">{{'Bronze Badge' | translate}}</p>
        <p *ngIf="badge == 'Silver'" class="mt-3 text-32-600-125 c-silver">{{'Silver Badge' | translate}}</p>
        <p *ngIf="badge == 'Gold'" class="mt-3 text-32-600-125 c-gold">{{'Gold Badge' | translate}}</p>
        <div class="mb-2 d-flex gap-3 align-items-center">
            <span class="text-36-600-122 text-c4" >{{'Congratulations!'|translate}}</span>
            <img src="assets/icons/party-popper.svg" alt="">
        </div>
        <p class="text-16-400-125">{{"You've Earned a New Badge!" |translate}}</p>
    </div>
</div>
